export default function MessagesPage() {
  return (
    <div className="flex flex-1">
      {/* Left: Conversation list */}
      <aside className="hidden md:block w-80 border-r border-border p-6 overflow-y-auto">
          <h2 className="text-base font-semibold mb-6">Conversations</h2>
          <ul className="space-y-4">
            {["Jane Doe", "Alex Johnson", "Chris Lee"].map((name, idx) => (
              <li key={idx}>
                <div className="flex items-start gap-3 hover:bg-surface-sunken p-3 rounded-lg transition cursor-pointer">
                  <div className="w-10 h-10 bg-surface-muted rounded-full" />
                  <div className="flex-1">
                    <p className="text-sm font-medium">{name}</p>
                    <p className="text-xs text-text-muted">
                      Just saw your note, replying now!
                    </p>
                  </div>
                  <span className="text-[10px] text-text-muted">2m</span>
                </div>
              </li>
            ))}
          </ul>
        </aside>

        {/* Right: Active conversation */}
        <section className="flex-1 flex flex-col relative bg-surface">
          {/* Header */}
          <div className="border-b border-border px-6 py-4 sticky top-0 bg-surface-elevated z-10">
            <h3 className="text-base font-semibold">Jane Doe</h3>
            <p className="text-xs text-text-muted">Last seen 2 mins ago</p>
          </div>

          {/* Messages */}
          <div className="flex-1 overflow-y-auto px-6 py-6 space-y-6">
            <Timestamp label="Today, 10:43 AM" />
            <Message text="Hey! Did you see the new update on the note?" />
            <Message
              text="Yep, I left my comments under yours. Should we sync?"
              isUser
            />
            <Message text="Sounds good. Free around 3?" />
          </div>

          {/* Input */}
          <div className="px-6 py-4 bg-surface-elevated border-t border-border backdrop-blur-md sticky bottom-0">
            <form className="flex gap-3">
              <input
                type="text"
                placeholder="Type your message..."
                className="flex-1 bg-surface-elevated border border-border-strong rounded-md px-4 py-2 text-sm text-text-primary focus:outline-none focus:ring-1 focus:ring-black"
              />
              <button
                type="submit"
                className="px-4 py-2 bg-black text-text-inverse rounded-md hover:bg-surface-dark transition"
              >
                Send
              </button>
            </form>
          </div>
        </section>
    </div>
  );
}

// Nav Item
function NavItem({ icon, label, active = false }) {
  return (
    <a
      href="#"
      className={`flex items-center gap-3 text-sm px-3 py-2 rounded-md transition ${
        active
          ? "bg-surface-muted text-black font-medium"
          : "text-text-secondary hover:bg-surface-sunken"
      }`}
    >
      {icon}
      <span>{label}</span>
    </a>
  );
}

// Message bubble
function Message({ text, isUser = false }) {
  return (
    <div className={`flex ${isUser ? "justify-end" : "justify-start"}`}>
      <div
        className={`max-w-xs px-4 py-2 rounded-xl text-sm shadow-sm ${
          isUser
            ? "bg-black text-text-inverse rounded-tr-none"
            : "bg-surface-elevated text-text-primary rounded-tl-none border border"
        }`}
      >
        {text}
      </div>
    </div>
  );
}

// Timestamp separator
function Timestamp({ label }) {
  return (
    <div className="text-center text-xs text-text-muted mt-2 mb-2">
      <span className="px-3 py-1 bg-surface-sunken rounded-full">{label}</span>
    </div>
  );
}
